import services from '@/services'

export default {
  cleanSingleSourceOfTruth: async (context) => {
    context.commit('SET_USUARIO', {})
    context.commit('SET_EMBARCADOR', {})
  },
  setUsuario: async (context, payload) => {
    context.commit('SET_USUARIO', payload)
    if (payload.embarcador.length > 0) {
      context.commit('SET_EMBARCADOR', payload.embarcador[0])
    }
  },
  setEmbarcador: async (context, payload) => {
    context.commit('SET_EMBARCADOR', payload)
  },
  setTotalFretesRascunho: async (context, payload) => {
    context.commit('SET_TOTAL_FRETES_RASCUNHO', payload)
  },
  addColaborador: async (context, payload) => {
    context.commit('ADD_COLABORADOR', payload)
  },
  delColaborador: async (context, payload) => {
    context.commit('DEL_COLABORADOR', payload)
  },
  delTransportador: async (context, payload) => {
    context.commit('DEL_TRANSPORTADOR', payload)
  },
  getEstados: async (context, payload) => {
    if (context.getters.getEstados.length === 0) {
      let response = await services.estados.getAll()
      context.commit('SET_ESTADOS', response)
    }
  },
  getCidades: async (context, payload) => {
    let estadoId = (typeof payload === 'undefined' || Number.isNaN(payload) || payload === 0) ? 29 : payload

    if (context.getters.getCidades[estadoId] === undefined) {
      let response = await services.cidades.getAllByEstadoId(estadoId)
      context.commit('SET_CIDADES', {estadoId, response})
    }

    return context.getters.getCidades[estadoId]
  },
  getCnaes: async (context) => {
    if (context.getters.getCnaes === null) {
      let response = await services.cnaes.getAll()
      context.commit('SET_CNAES', {response})
    }

    return context.getters.getCnaes
  },
  setLoginExpired: async (context, payload) => {
    context.commit('SET_AUTH_LOGIN_EXPIRED', payload)
  }
}



// WEBPACK FOOTER //
// ./src/vuex/actions.js